import '../../App.css';
import Box from 'carbon-react/esm/components/box';
import { Breadcrumbs, Crumb } from 'carbon-react/esm/components/breadcrumbs';
import Typography from 'carbon-react/esm/components/typography';
import Icon from 'carbon-react/esm/components/icon';
import Divider from 'carbon-react/lib/components/divider';
import { Link } from 'react-router-dom';
import { AppRoutes } from '../../types/appRoutes';
import DsnDetailsContent from './component/DsnDetailsContent';

export default function DsnDetails() {
  return (
    <Box paddingTop={3}>
      <Breadcrumbs aria-label="Default breadcrumbs">
        <Crumb>
          <Link to={AppRoutes.routeDsnList}>Liste des DSN</Link>
        </Crumb>
        <Crumb href="#" isCurrent>
          Détail de la déclaration
        </Crumb>
      </Breadcrumbs>
      <Box display="flex" alignItems="center" margin="16px 0 8px">
        <Icon type="entry" marginRight={2} />
        <Typography variant="h1">Détail de la déclaration</Typography>
      </Box>
      <Divider type="horizontal" mt={1} mb={2} />
      <DsnDetailsContent />
    </Box>
  );
}
